export default "/bundles/assets/photo3_5ab6e83b52c5717bc9f89a1133470dc3.png";